import React, { useRef } from 'react'
import { useFrame } from '@react-three/fiber'
import { useScroll } from '@react-three/drei'
import { useThree } from '@react-three/fiber'
import * as THREE from 'three'
import App from '../../../css/App.scss'
import { Line } from '@react-three/drei'

export default function Minimap({ items }) {
  const minimapRef = useRef()
  const scroll = useScroll()
  const { height } = useThree((state) => state.viewport)

  const damp = THREE.MathUtils.damp

  useFrame((state, delta) => {
    minimapRef.current.children.forEach((child, index) => {
      const y = scroll.curve(index / items.length - 0.15 / items.length, 4 / items.length)
      child.scale.y = damp(child.scale.y, .1 + y, .8, .2, delta)
    })
  })
  
  return (
    <group ref={minimapRef}>
      {items?.map((_, i) => (
        <group key={i} position={[i * 15 - items.length * 7, - height / 2 + 25, -5]}>
          <Line points={[new THREE.Vector3(0, -20, 0), new THREE.Vector3(0, 20, 0)]} color={App.secondaryColor} lineWidth={1}/>
        </group>
      ))}
    </group>
  )
}